import React from 'react'

const SavePopup = ({ closePopup, popupStatus }) => (
    <div className="phocket-popup  ">
        <button className="close" onClick={e => closePopup()}>&times;</button>
        <span>{popupStatus}</span>
    </div>
)

export default SavePopup;